<script>
  export default {
    name: 'KrdCheckbox',

    props: {
      modelValue: {
        type: Boolean,
        default: false
      },

      disabled: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      isChecked: {
        get() {
          return this.modelValue;
        },

        set(newValue) {
          this.$emit('update:model-value', newValue)
          this.$emit('change', newValue)
        }
      },

      classes() {
        return [
          'krd-checkbox',
          this.isChecked && 'krd-checkbox_is-checked'
        ]
      }
    }
  }
</script>

<template>
  <label :class="classes">
    <input
      type="checkbox"
      :checked="isChecked"
      :disabled="disabled"
      class="krd-checkbox__input"
      @change="isChecked = $event.target.checked"
    >
    <div class="krd-checkbox__box"></div>
    <div class="krd-checkbox__label">
      <slot></slot>
    </div>
  </label>
</template>

<style lang="scss" scoped>
  .krd-checkbox {
    display: flex;
    align-items: flex-start;
    cursor: pointer;

    &__box {
      flex: none;
      width: 20px;
      height: 20px;
      display: block;
      border-radius: 6px;
      border: 2px solid #dcdde0;
      margin-right: 10px;
    }

    &__label {
      margin-top: 3px;
    }

    input {
      display: none;
    }

    &_is-checked {
      .krd-checkbox__box {
        border: initial;
        background-image: url('/assets/img/checkbox.svg');
      }
    }
  }
</style>
